export default "__VITE_ASSET__DFK8TFR8__"